import { defaultTheme } from "react-admin";
import merge from "lodash.merge";
import { createMuiTheme, ThemeOptions } from "@material-ui/core/styles";
import { brandColors, semanticColors } from "../lib/constants/colors";

// Create a theme instance
const theme = createMuiTheme(
  merge({}, defaultTheme, {
    sidebar: {
      width: 200,
    },
    menu: {
      width: 200,
    },
    palette: {
      primary: {
        main: semanticColors.primary,
        contrastText: brandColors.justWhite,
      },
      secondary: {
        main: semanticColors.secondary,
        contrastText: brandColors.justWhite,
      },
      error: {
        main: semanticColors.error,
        contrastText: brandColors.justWhite,
      },
      warning: {
        main: semanticColors.warning,
        contrastText: brandColors.notBlack,
      },
      info: {
        main: semanticColors.info,
        contrastText: brandColors.justWhite,
      },
      success: {
        main: semanticColors.success,
        contrastText: brandColors.notBlack,
      },
      text: {
        primary: brandColors.notBlack,
        secondary: brandColors.notBlack,
      },
      background: {
        default: brandColors.justWhite,
        paper: brandColors.cementGray,
      },
    },
    typography: {
      // eslint-disable-next-line quotes
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
      button: {
        textTransform: "none" as const,
      },
      body2: {
        fontSize: 12,
        color: brandColors.notBlack,
      },
      h1: {
        color: brandColors.notBlack,
      },
      h2: {
        color: brandColors.notBlack,
      },
      h3: {
        color: brandColors.notBlack,
      },
      h4: {
        color: brandColors.notBlack,
      },
      h5: {
        color: brandColors.notBlack,
      },
      h6: {
        color: brandColors.notBlack,
      },
      body1: {
        color: brandColors.notBlack,
      },
    },
    overrides: {
      RaImageInput: {
        dropZone: {
          border: `1px dashed ${brandColors.cementGray}`,
          fontSize: 12,
          padding: 10,
          borderRadius: 8,
          backgroundColor: "rgb(250, 250, 250)",
        },
      },
      MuiButton: {
        root: {
          borderRadius: 8,
          padding: "8px 16px",
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
        containedPrimary: {
          "&:hover": {
            backgroundColor: semanticColors.primary,
            opacity: 0.9,
          },
        },
        containedSecondary: {
          backgroundColor: semanticColors.secondary,
          "&:hover": {
            backgroundColor: semanticColors.secondary,
            opacity: 0.9,
          },
        },
        outlined: {
          borderWidth: 2,
          "&:hover": {
            borderWidth: 2,
          },
        },
      },
      MuiTextField: {
        root: {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: brandColors.cementGray,
            },
            "&:hover fieldset": {
              borderColor: semanticColors.primary,
            },
            "&.Mui-focused fieldset": {
              borderColor: semanticColors.primary,
            },
          },
        },
      },
      MuiCard: {
        root: {
          backgroundColor: brandColors.justWhite,
          boxShadow: "none",
          border: `1px solid ${brandColors.cementGray}`,
        },
      },
      MuiPaper: {
        root: {
          backgroundColor: brandColors.justWhite,
        },
        elevation1: {
          boxShadow: "none",
          border: `1px solid ${brandColors.cementGray}`,
        },
      },
    },
  } as ThemeOptions)
);

export default theme;
